
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
	import Switch from '@/components/switch.vue';
	import {
		getOssToken
	} from '@/api/user'
	import {
		productList,
		productCategory
	} from '@/api/supplier'
	import {
		createBanner,
		setBanner,
		bannerDetail,
		getBackendActivityList,
		custompagecustompagelist,
		productfilterBoxList
	} from '@/api/material'
	
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"
import { start } from "nprogress";
	@Component({
		name: 'banner-detail',
		components: {
			PageFooter,
			UploadImg,
			'slz-switch': Switch
		}
	})
	export default class BannerDetail extends Vue {
		private pageType = this.$route.query.type;
		private id = +this.$route.query.id;
		private token: any = {};
		private formData: any = {
			id: 0,
			name: '',
			pic: [],
			path: '',
			product_id: '',
			information_id: '',
			banner_type: 0,
			state: 1,
			classityId:'',
			BackgroundColor:'#F9D5AF',
			StartTime:'',
			EndTime:'',
		};

		private bindType = 0
		private bindTypes: any = [{
				label: '不关联',
				value: 0
			}, {
				label: '商品关联',
				value: 1
			}, 
			// {
			// 	label: '文章关联',
			// 	value: 2
			// }, 
			// {
			// 	label: '网址关联',
			// 	value: 3
			// }, 
			{
				label: '商品分类',
				value: 4
			}, 
			{
				label: '自定义页面',
				value: 5
			}
		]
		private loadingProduct = false
		private productlst = []
		private informationlist = []
		private classityList:any = []
		private pageList:any = []

		private mounted() {
			// console.log(nextDay(getSearchDate(0)[0],1))
			this.formData.StartTime = nextDay(getSearchDate(0)[0],1) + ' 00:00:00'
			this.formData.EndTime = nextDay(getSearchDate(0)[0],4) + ' 00:00:00'
			// console.log(this.formData.StartTime,this.formData.EndTime)
			if (this.pageType === 'edit') {
				this.getBanner()
			}
			this.getList()
		}


		private async getcustompage(){
			try{
				let res = await custompagecustompagelist({
					PageName:'',
					Skip:0,
					Take:99999
				})
				if(res.IsSuccess){
					this.pageList = res.Result.Results
				}
			}finally{
				//
			}
		}
		private changeselect(e){
			console.log(e)
			if(e==1){
				this.getProductList()
			}else if(e==4){
				this.getList()
			}else if(e==5){
				this.getcustompage()
			}
		}

		// 获取列表
		private async getList() {
			let params: any = {
				Skip: 0,
				Take: 99999,
				Keywords: ''
			}
			try {
				const res: any = await productCategory(params);
				this.classityList = res.Result.Results;
			} catch (err) {
				console.error('getProviderStatistics ===>', err)
			}
		}

		private async getBanner() {
			try {
				const res: any = await bannerDetail({
					Id: this.id
				})
				this.formData = {
					id: this.id,
					name: res.Result.Title,
					pic: res.Result.ImgUrl ? [res.Result.ImgUrl] : [],
					information_id: '',
					state: res.Result.IsDisplay,
					product_id: '',
					banner_type: res.Result.RelationType,
					path: '',
					classityId:'',
					BackgroundColor:res.Result.BackgroundColor,
					StartTime:res.Result.StartTime,
					EndTime:res.Result.EndTime,
					pageId:'',
				}

				if (res.Result.RelationType===1){
					this.formData.product_id = res.Result.RelationId
					this.getProductListForId(res.Result.RelationId)
				}else if(res.Result.RelationType===2){
					this.formData.information_id = res.Result.RelationId
				}else if(res.Result.RelationType===3){
					this.formData.path = res.Result.LinkUrl
				}else if(res.Result.RelationType===4){
					await this.getList()
					this.formData.classityId = this.classityList.find(v=>v.Id==res.Result.RelationId)?.Id || ''
				}else if(res.Result.RelationType===5){
					await this.getcustompage()
					this.formData.pageId = this.pageList.find(v=>v.Id==res.Result.RelationId)?.Id || ''
				}



				// console.log(this.formData)
			} catch (e) {
				console.log(e)
			}
		}

		private async getToken() {
			try {
				const res: any = await getOssToken({})
				this.token = {
					AccessKeySecret: res.access_key_secret,
					OSSAccessKeyId: res.access_key_id,
					SecurityToken: res.security_token
				}
			} catch (e) {
				console.log('getOssToken ===>', e)
			}
		}

		private toBack() {
			this.$router.go(-1)
		}

		// 提交信息
		private submit() {
			// if (!this.formData.name) {
			// 	this.$message('请输入标题名称');
			// 	return false;
			// }
			if (!this.formData.pic || !this.formData.pic.length) {
				this.$message('请上传轮播');
				return false;
			}
			let start = new Date(this.formData.StartTime).getTime()
			let end = new Date(this.formData.EndTime).getTime()
			if((!start&&end)||(start&&!end)){
				this.$message('请选择正确的时间');
				return false;
			}else if(start&&end&&(end<=start)){
				this.$message('请选择正确的时间');
				return false;
			}

			this.doCreate();
		}

		// 创建
		private async doCreate() {
			let params:any = {
				Id: this.id,
				Title: this.formData.name,
				ImgUrl: this.formData.pic[0],
				RelationType: this.formData.banner_type,
				LinkUrl: this.formData.path,
				IsDisplay: this.formData.state,
				BackgroundColor:this.formData.BackgroundColor,
				StartTime:this.formData.StartTime,
				EndTime:this.formData.EndTime,
			}

			if (this.formData.banner_type === 1){
				params.RelationId = this.formData.product_id;
			}else if (this.formData.banner_type === 2){
				params.RelationId = this.formData.information_id;
			}else if (this.formData.banner_type === 4){
				params.RelationId = this.formData.classityId;
			}else if (this.formData.banner_type === 5){
				params.RelationId = this.formData.pageId;
			}

			try {
				await createBanner(params)
				this.$message({
					type: 'success',
					message: this.id ? '编辑成功':'创建成功！',
					onClose: () => {}
				})
				this.toBack();
			} catch (e) {
				console.log('createBanner ===>', e)
			}
		}

		// 编辑
		private async doEdit() {
			let params: any = JSON.parse(JSON.stringify(this.formData))
			params.pic = params.pic[0];
			params.product_id = params.product_id || 0;
			params.information_id = params.information_id || 0
			params.state = +params.state;
			try {
				await setBanner(params)
				this.$message({
					type: 'success',
					message: '更新成功！',
					onClose: () => {}
				})
				this.toBack()
			} catch (e) {
				console.log('setBanner ===>', e)
			}
		}

		// 上传回调
		private handleUpload(list: any) {
			this.formData.pic = list
		}

		// 选择回调
		private handleSelect(e: any) {
			if (!this.formData.banner_type) {
				this.formData.product_id = e
			} else {
				this.formData.path = e
			}
		}

		// 商品列表
		private async getProductList(query ? : string) {
			if (!query.length) return;
			this.loadingProduct = true;
			const params: any = {
				Skip: 0,
				Take: 9999,
				Keywords: query || ''
			}
			try {
				const res: any = await productList(params)
				if (res.IsSuccess) {
					this.productlst = res.Result.Results;
				} else {
					this.productlst = [];
				}
				this.loadingProduct = false;
			} catch (e) {
				this.loadingProduct = false;
			}
		}

		// 商品列表
		private async getProductListForId(query ? : number) {
			const params: any = {
				Skip: 0,
				Take: 9999,
				ProductId : query || ''
			}
			try {
				const res: any = await productList(params)
				if (res.IsSuccess) {
					this.productlst = res.Result.Results;
				} else {
					this.productlst = [];
				}
				this.loadingProduct = false;
			} catch (e) {
				this.loadingProduct = false;
			}
		}

		// 获取资讯列表
		private async getInformation(query ? : string) {
			if (!query.length) return;
			this.loadingProduct = true;
			const params: any = {
				page_no: 1,
				page_size: 9999
			}
			if (query) {
				params.keyword = query
			}
			try {
				const res: any = await getBackendActivityList(params);
				this.loadingProduct = false;
				this.informationlist = res.info || []
			} catch (e) {
				this.loadingProduct = false;
				console.log(e)
			}
		}
	}
